module.exports = __webpack_public_path__ + "static/img/FEELER.0f0efc96.png";